<script>

export default {
  name: 'PageContainer',
  data() {
    return {
      leftWidth: '300px',
      rightWidth: '300px'
    }
  },
  methods: {
    onChangeLeftStatus() {
      this.leftWidth = this.leftWidth === '0' ? '300px' : '0'
    },
    onChangeRightStatus() {
      this.rightWidth = this.rightWidth === '0' ? '300px' : '0'
    }
  }
}
</script>

<template>
  <el-container class="cati-container">
    <el-aside class="cati-left" :class="{'cati-left-border': leftWidth!=='0'}" :width="leftWidth">
      <div class="left-wrap" style="width: 300px">
        <slot name="left"></slot>
      </div>
      <div class="collapse-icon" @click="onChangeLeftStatus">
        <span>
          <i class="el-icon-arrow-right" v-if="leftWidth==='0'"></i>
          <i class="el-icon-arrow-left" v-else></i>
        </span>
      </div>
    </el-aside>
    <el-main class="cati-main">
      <div class="h-full w-full">
        <slot></slot>
      </div>
    </el-main>
    <!--    <el-aside class="cati-right" :width="rightWidth">-->
    <!--      <div class="right-wrap" style="width: 300px">-->
    <!--        <slot name="right"></slot>-->
    <!--      </div>-->
    <!--      <div class="collapse-icon" @click="onChangeRightStatus"></div>-->
    <!--    </el-aside>-->
  </el-container>
</template>

<style scoped lang="scss">
.cati-container {
  height: 100%;
  width: 100%;
  font-size: 14px;
  //position: relative;
  overflow: hidden;

  .cati-left-border {
    @apply border-r border-solid border-border-gray;
  }

  .cati-left,
  .cati-right {
    height: 100%;
    position: relative;
    overflow: visible;
    transition: all .3s;

    .collapse-icon {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 50px;
      top: 50%;
      border-radius: 2px;
      @apply text-theme cursor-pointer bg-theme-100;
    }
  }

  .cati-left {
    .collapse-icon {
      right: -16px;
    }

    .left-wrap {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }

  .cati-right {
    .collapse-icon {
      left: -16px;
    }

    .right-wrap {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
    }
  }

  .cati-main {
    height: 100%;
    padding: 0 20px;
    @apply bg-bg-common-color;
  }
}
</style>